<template>

    <span class="h6 mb-0 font-weight-bold font-alternate">
        € {{$root.currencyDisplaySimple(price)}}
    </span>

</template>

<script>
export default {
    props: ['product'],
    data() {
        return {
            year: null,
            price: null,
        }
    },
    created() {

        this.product.combinations.sort(function(a, b) {
            return parseFloat(a.price) - parseFloat(b.price);
        });

        let found = false;

        for(let j=0; j<this.product.combinations.length; j++) {
            if(this.product.combinations[j].code.indexOf('bottiglia') > -1 && this.product.combinations[j].code.indexOf('mezza') == -1 && !found) {
                found = true;
                this.price = this.product.combinations[j].price;
                for(let i=0; i<this.product.combinations[j].attributes.length; i++) {
                    if(this.product.combinations[j].attributes[i].key == 'anno') {
                        this.year = this.product.combinations[j].attributes[i].value_label;
                    }
                }
            }
        }

        if(!found) {
            this.price = this.product.combinations[0].price;
            for(let i=0; i<this.product.combinations[0].attributes.length; i++) {
                if(this.product.combinations[0].attributes[i].key == 'anno') {
                    this.year = this.product.combinations[0].attributes[i].value_label;
                }
            }
        }

    },
    mounted() {
    },
    methods: {
    },
    computed: {
    }
}
</script>
